export default __webpack_public_path__ + "static/media/1948.80d46840.png";